import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import Particles from './components/Particles/Particles'
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux-toolkit';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
        <Particles />
      </Router>
    </Provider>
  </React.StrictMode>

);

